<div class="py-20">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Title -->
    <div class="text-center mb-16">
      <h2 class="h2 text-text-primary">{{ 'about.values.title' | translate }}</h2>
    </div>

    <!-- Values Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 auto-rows-fr">
      @for (v of values; track v.title) {
        <app-our-values-card class="block h-full" [value]="v"></app-our-values-card>
      }
    </div>
  </div>
</div>
